import { SendToAgenciesSummaryViewComponent } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/SendToAgenciesSummaryView.component';
import { SendToAgenciesSummaryViewPropsProvider } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/SendToAgenciesSummaryView.props.context';
import { FC } from 'react';

export const SendToAgenciesSummaryView: FC = () => {
  return (
    <SendToAgenciesSummaryViewPropsProvider>
      <SendToAgenciesSummaryViewComponent />
    </SendToAgenciesSummaryViewPropsProvider>
  );
};
